import _defineProperty from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { isArray } from 'lodash';
import qs from 'qs';
import { formatCurrency } from '../../shared/formatters';
import { filterOutRequestExtraParameters, handleApiRequestSuccessData, handleRequestError } from '../../utils/request';
import { api } from '../index';
import { combineQuoteCoverOptionList, handleQuotePriceDateInfo } from '../utils/quote';
export var apiGetQuoteComparisonPriceInformation = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(payload) {
    var _res$data, _res$data$data, _res$data2, _res$data2$data, res, _res$data$data$jove_q, originPriceData, coverOptions, _res$data$data$compar, annual_saving, currency, saving_percentage, your_policy_annual_premium, your_policy_monthly_premium, your_policy_total_payable;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return api.get("/switch_to_jove/price-comparison/".concat(payload === null || payload === void 0 ? void 0 : payload.quoteId));

          case 3:
            res = _context.sent;
            handleApiRequestSuccessData(res);

            if (res !== null && res !== void 0 && (_res$data = res.data) !== null && _res$data !== void 0 && (_res$data$data = _res$data.data) !== null && _res$data$data !== void 0 && _res$data$data.jove_quote_price) {
              originPriceData = res.data.data.jove_quote_price;
              coverOptions = ((_res$data$data$jove_q = res.data.data.jove_quote_price) === null || _res$data$data$jove_q === void 0 ? void 0 : _res$data$data$jove_q.covers_options) || {};
              combineQuoteCoverOptionList(coverOptions, originPriceData, {
                useDefault: true
              });
              originPriceData = handleQuotePriceDateInfo(originPriceData);
              res.data.data.jove_quote_price = originPriceData;
            }

            if (res !== null && res !== void 0 && (_res$data2 = res.data) !== null && _res$data2 !== void 0 && (_res$data2$data = _res$data2.data) !== null && _res$data2$data !== void 0 && _res$data2$data.comparison) {
              _res$data$data$compar = res.data.data.comparison, annual_saving = _res$data$data$compar.annual_saving, currency = _res$data$data$compar.currency, saving_percentage = _res$data$data$compar.saving_percentage, your_policy_annual_premium = _res$data$data$compar.your_policy_annual_premium, your_policy_monthly_premium = _res$data$data$compar.your_policy_monthly_premium, your_policy_total_payable = _res$data$data$compar.your_policy_total_payable;
              res.data.data.comparison = _objectSpread(_objectSpread({}, res.data.data.comparison), {}, {
                annualSavingText: formatCurrency({
                  amount: annual_saving,
                  currency: currency
                }),
                savingPercentage: saving_percentage,
                policyAnnualPremiumText: formatCurrency({
                  amount: your_policy_annual_premium,
                  currency: currency
                }),
                policyMonthlyPremiumText: formatCurrency({
                  amount: your_policy_monthly_premium,
                  currency: currency
                }),
                policyAnnualTotalText: formatCurrency({
                  amount: your_policy_total_payable,
                  currency: currency
                })
              });
            }

            return _context.abrupt("return", [res.data]);

          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", handleRequestError(_context.t0, payload));

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 10]]);
  }));

  return function apiGetQuoteComparisonPriceInformation(_x) {
    return _ref.apply(this, arguments);
  };
}();
export var apiConfirmPayAssumptionQuoteDetailInfo = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return api.patch("/quotes/assumption-quote/".concat(payload === null || payload === void 0 ? void 0 : payload.quoteId), filterOutRequestExtraParameters(payload));

          case 3:
            res = _context2.sent;
            handleApiRequestSuccessData(res);
            return _context2.abrupt("return", [res.data]);

          case 8:
            _context2.prev = 8;
            _context2.t0 = _context2["catch"](0);
            return _context2.abrupt("return", handleRequestError(_context2.t0, payload));

          case 11:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 8]]);
  }));

  return function apiConfirmPayAssumptionQuoteDetailInfo(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
export var apiGetQuoteAssumDetailInfo = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return api.get("/switch_to_jove/assumptions/".concat(payload === null || payload === void 0 ? void 0 : payload.quoteId));

          case 3:
            res = _context3.sent;
            handleApiRequestSuccessData(res);
            return _context3.abrupt("return", [res.data]);

          case 8:
            _context3.prev = 8;
            _context3.t0 = _context3["catch"](0);
            return _context3.abrupt("return", handleRequestError(_context3.t0, payload));

          case 11:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 8]]);
  }));

  return function apiGetQuoteAssumDetailInfo(_x3) {
    return _ref3.apply(this, arguments);
  };
}();
export var apiUploadPolicyDocumentByQuoteId = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            _context4.next = 3;
            return api.post("/switch_to_jove/upload-policy-pdf/".concat(payload === null || payload === void 0 ? void 0 : payload.quoteId), payload.formData, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            });

          case 3:
            res = _context4.sent;
            handleApiRequestSuccessData(res);
            return _context4.abrupt("return", [res.data]);

          case 8:
            _context4.prev = 8;
            _context4.t0 = _context4["catch"](0);
            return _context4.abrupt("return", handleRequestError(_context4.t0, payload));

          case 11:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[0, 8]]);
  }));

  return function apiUploadPolicyDocumentByQuoteId(_x4) {
    return _ref4.apply(this, arguments);
  };
}();
export var apiGetQuickCalulateBusinessActivities = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(payload) {
    var _res$data3, res;

    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            _context5.next = 3;
            return api.get("/switch_to_jove/website/universal/business-activities?".concat(qs.stringify(filterOutRequestExtraParameters(payload))));

          case 3:
            res = _context5.sent;
            handleApiRequestSuccessData(res);

            if (isArray(res === null || res === void 0 ? void 0 : (_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : _res$data3.data)) {
              res.data.data.forEach(function (item) {
                item.label = item.value;
                item.value = item.id;
              });
            }

            return _context5.abrupt("return", [res.data]);

          case 9:
            _context5.prev = 9;
            _context5.t0 = _context5["catch"](0);
            return _context5.abrupt("return", handleRequestError(_context5.t0, payload));

          case 12:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[0, 9]]);
  }));

  return function apiGetQuickCalulateBusinessActivities(_x5) {
    return _ref5.apply(this, arguments);
  };
}();
export var apiCreateQuickCalulateQuote = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;
            _context6.next = 3;
            return api.post("/switch_to_jove/website/create-assumption-quote", payload);

          case 3:
            res = _context6.sent;
            handleApiRequestSuccessData(res);
            return _context6.abrupt("return", [res.data]);

          case 8:
            _context6.prev = 8;
            _context6.t0 = _context6["catch"](0);
            return _context6.abrupt("return", handleRequestError(_context6.t0, payload));

          case 11:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[0, 8]]);
  }));

  return function apiCreateQuickCalulateQuote(_x6) {
    return _ref6.apply(this, arguments);
  };
}();
export var apiCreateQuoteWithPolicyDocuments = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.prev = 0;
            _context7.next = 3;
            return api.post("/switch_to_jove/website/upload-file-create-assumption-quote", payload.formData, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            });

          case 3:
            res = _context7.sent;
            handleApiRequestSuccessData(res);
            return _context7.abrupt("return", [res.data]);

          case 8:
            _context7.prev = 8;
            _context7.t0 = _context7["catch"](0);
            return _context7.abrupt("return", handleRequestError(_context7.t0, payload));

          case 11:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, null, [[0, 8]]);
  }));

  return function apiCreateQuoteWithPolicyDocuments(_x7) {
    return _ref7.apply(this, arguments);
  };
}();
export var apiGetQuoteBindPolicyDocuments = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(payload) {
    var _res$data4, res;

    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.prev = 0;
            _context8.next = 3;
            return api.get("/admin/quotes/".concat(payload === null || payload === void 0 ? void 0 : payload.quoteId, "/extracted-policy-info/uploaded-documents"));

          case 3:
            res = _context8.sent;
            handleApiRequestSuccessData(res);

            if (isArray(res === null || res === void 0 ? void 0 : (_res$data4 = res.data) === null || _res$data4 === void 0 ? void 0 : _res$data4.data)) {
              res.data.data = res.data.data.map(function (item) {
                var _item$revision, _item$revision2, _item$revision3;

                return _objectSpread(_objectSpread(_objectSpread({}, item), item.document), {}, {
                  download_url: item.url,
                  value: (_item$revision = item.revision) === null || _item$revision === void 0 ? void 0 : _item$revision.id,
                  label: (_item$revision2 = item.revision) === null || _item$revision2 === void 0 ? void 0 : _item$revision2.filename,
                  title: (_item$revision3 = item.revision) === null || _item$revision3 === void 0 ? void 0 : _item$revision3.filename
                });
              });
            }

            return _context8.abrupt("return", [res.data]);

          case 9:
            _context8.prev = 9;
            _context8.t0 = _context8["catch"](0);
            return _context8.abrupt("return", handleRequestError(_context8.t0, payload));

          case 12:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, null, [[0, 9]]);
  }));

  return function apiGetQuoteBindPolicyDocuments(_x8) {
    return _ref8.apply(this, arguments);
  };
}();
export var apiUploadPolicyDocumentByQuoteIdInTheCMS = /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.prev = 0;
            _context9.next = 3;
            return api.post("/admin/quotes/".concat(payload === null || payload === void 0 ? void 0 : payload.quoteId, "/extracted-policy-info/upload-files"), payload.formData, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            });

          case 3:
            res = _context9.sent;
            handleApiRequestSuccessData(res);
            return _context9.abrupt("return", [res.data]);

          case 8:
            _context9.prev = 8;
            _context9.t0 = _context9["catch"](0);
            return _context9.abrupt("return", handleRequestError(_context9.t0, payload));

          case 11:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9, null, [[0, 8]]);
  }));

  return function apiUploadPolicyDocumentByQuoteIdInTheCMS(_x9) {
    return _ref9.apply(this, arguments);
  };
}();
export var apiGetQuoteExtratedDataFromPolicyDocuments = /*#__PURE__*/function () {
  var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            _context10.prev = 0;
            _context10.next = 3;
            return api.get("/admin/quotes/".concat(payload === null || payload === void 0 ? void 0 : payload.quoteId, "/extracted-policy-info?").concat(qs.stringify(filterOutRequestExtraParameters(payload))));

          case 3:
            res = _context10.sent;
            handleApiRequestSuccessData(res);
            return _context10.abrupt("return", [res.data]);

          case 8:
            _context10.prev = 8;
            _context10.t0 = _context10["catch"](0);
            return _context10.abrupt("return", handleRequestError(_context10.t0, payload));

          case 11:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10, null, [[0, 8]]);
  }));

  return function apiGetQuoteExtratedDataFromPolicyDocuments(_x10) {
    return _ref10.apply(this, arguments);
  };
}();
export var apiUpdateQuoteDocumentsParsedData = /*#__PURE__*/function () {
  var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            _context11.prev = 0;
            _context11.next = 3;
            return api.put("/admin/quotes/".concat(payload === null || payload === void 0 ? void 0 : payload.quoteId, "/update/extracted-policy-info"), payload);

          case 3:
            res = _context11.sent;
            handleApiRequestSuccessData(res);
            return _context11.abrupt("return", [res.data]);

          case 8:
            _context11.prev = 8;
            _context11.t0 = _context11["catch"](0);
            return _context11.abrupt("return", handleRequestError(_context11.t0, payload));

          case 11:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11, null, [[0, 8]]);
  }));

  return function apiUpdateQuoteDocumentsParsedData(_x11) {
    return _ref11.apply(this, arguments);
  };
}();